export default __webpack_public_path__ + "static/media/icons8-commercial-64 1.b5d6bf31.svg";